// pages/RemplissageSoldesPage.jsx
// INSERT du report 2025 uniquement - Ne touche pas au solde 2026
import React, { useEffect, useState } from 'react';
import api from '../services/api';
import { Save, RefreshCw, CheckCircle, AlertCircle, Calculator } from 'lucide-react';

export default function RemplissageSoldesPage() {
  const [employes, setEmployes] = useState([]);
  const [soldesSaisis, setSoldesSaisis] = useState({});
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const [message, setMessage] = useState({ type: '', text: '' });

  const anneeCourante = new Date().getFullYear(); // 2026
  const anneeN1 = anneeCourante - 1;               // 2025

  useEffect(() => {
    fetchEmployes();
  }, []);

  const fetchEmployes = async () => {
    setLoading(true);
    try {
      const res = await api.get('/employes');
      setEmployes(res.data.employes || []);
    } catch (err) {
      setMessage({ type: 'error', text: 'Erreur lors du chargement' });
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (employeId, value) => {
    setSoldesSaisis(prev => ({
      ...prev,
      [employeId]: parseFloat(value) || 0
    }));
  };

  const saveAll = async () => {
    setSaving(true);
    setMessage({ type: '', text: '' });
    
    let successCount = 0;
    let errorCount = 0;
    
    for (const emp of employes) {
      const report = soldesSaisis[emp.ID_Employes] || 0;
      
      // Ignorer si pas de report saisi
      if (report === 0) {
        continue;
      }
      
      try {
        // INSERT 2025 uniquement
        await api.post('/soldes', {
          ID_Employe: emp.ID_Employes,
          ID_TypeConge: 1,
          Annee: anneeN1,
          JoursAcquis: report,
          JoursPris: 0,
          JoursRestants: report
        });
        
        successCount++;
      } catch (err) {
        errorCount++;
      }
    }
    
    setMessage({
      type: successCount > 0 ? 'success' : 'error',
      text: `${successCount} reports enregistrés (${errorCount} erreurs)`
    });
    
    if (successCount > 0) {
      setSoldesSaisis({});
    }
    
    setTimeout(() => setMessage({ type: '', text: '' }), 4000);
    setSaving(false);
  };

  return (
    <div className="p-6 bg-gray-50 min-h-screen">
      
      <div className="flex justify-between items-center mb-6">
        <div>
          <h2 className="text-2xl font-bold text-gray-800 flex items-center gap-2">
            <Calculator size={24} className="text-purple-600" />
            Remplissage des reports
          </h2>
          <p className="text-sm text-gray-500 mt-1">
            Report des jours restants de l'année {anneeN1} vers {anneeCourante}
          </p>
        </div>
        <div className="flex gap-2">
          <button 
            onClick={fetchEmployes} 
            className="p-2 text-gray-500 hover:text-purple-600 transition rounded-lg hover:bg-white"
          >
            <RefreshCw size={18} />
          </button>
          <button
            onClick={saveAll}
            disabled={saving || loading}
            className="px-4 py-2 bg-purple-600 text-white rounded-lg text-sm flex items-center gap-2 hover:bg-purple-700 transition disabled:opacity-50 shadow-sm"
          >
            <Save size={16} /> Enregistrer tout
          </button>
        </div>
      </div>

      {message.text && (
        <div className={`mb-4 p-3 rounded-lg flex items-center gap-2 ${
          message.type === 'success' ? 'bg-green-50 text-green-700 border border-green-200' : 'bg-red-50 text-red-700 border border-red-200'
        }`}>
          {message.type === 'success' ? <CheckCircle size={16} /> : <AlertCircle size={16} />}
          {message.text}
        </div>
      )}

      <div className="bg-white rounded-xl shadow-sm border overflow-hidden">
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead>
              <tr className="bg-gray-50 text-xs text-gray-500">
                <th className="px-4 py-3 text-left">Employé</th>
                <th className="px-4 py-3 text-center w-40">
                  Jours restants {anneeN1} à reporter
                </th>
              </tr>
            </thead>
            <tbody className="divide-y">
              {loading ? (
                <tr>
                  <td colSpan="2" className="px-4 py-12 text-center text-gray-400">
                    <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-purple-700 mx-auto"></div>
                  </td>
                </tr>
              ) : employes.length === 0 ? (
                <tr>
                  <td colSpan="2" className="px-4 py-12 text-center text-gray-400">
                    Aucun employé trouvé
                  </td>
                </tr>
              ) : (
                employes.map(emp => (
                  <tr key={emp.ID_Employes} className="hover:bg-gray-50 transition">
                    <td className="px-4 py-3">
                      <div className="font-medium text-gray-800">{emp.Prenom} {emp.Nom}</div>
                      <div className="text-xs text-gray-400">{emp.Matricule}</div>
                    </td>
                    <td className="px-4 py-3 text-center">
                      <input
                        type="number"
                        step="0.5"
                        min="0"
                        className="w-28 p-2 border rounded-lg text-center focus:ring-2 focus:ring-purple-500"
                        value={soldesSaisis[emp.ID_Employes] || ''}
                        onChange={(e) => handleChange(emp.ID_Employes, e.target.value)}
                        placeholder="0"
                      />
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
        
        <div className="px-6 py-3 border-t bg-gray-50 text-xs text-gray-500">
          💡 INSERT dans SoldesConge pour l'année {anneeN1}. Le solde {anneeCourante} reste inchangé.
        </div>
      </div>
    </div>
  );
}